import PropTypes from 'prop-types';

import { FormReader } from '@/components/forms';
import { multipleFileDownload } from '@/utils/downloadFile/multipleFileDownload';
import { downloadFile } from '@/utils/downloadFile';

export const FormBody = ({
  linkCreatedByAccount,
  link,
  traceId,
  workflowContext
}) => {
  const { action, data } = link;
  const { description } = action || {};

  const schema = action?.form?.schema || {
    type: 'object',
    description: action?.description
  };
  const uiSchema = action?.form?.uiSchema || {};
  const { name } = linkCreatedByAccount?.entity || link.group;

  if (!action) {
    // Fallback on displaying the JSON data if
    // action is not set for some reason.
    return <pre>{JSON.stringify(data, null, 2)}</pre>;
  }

  const formData = link?.answer
    ? { comment: link.answer, files: link.files }
    : data;

  return (
    <FormReader
      description={description}
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      who={name}
      when={link.createdAt}
      workflowContext={workflowContext}
      downloadFile={downloadFile}
      downloadAllFiles={multipleFileDownload}
    />
  );
};

FormBody.propTypes = {
  action: PropTypes.object,
  data: PropTypes.object,
  linkCreatedByAccount: PropTypes.object,
  link: PropTypes.object.isRequired,
  traceId: PropTypes.string.isRequired,
  workflowContext: PropTypes.object.isRequired
};
